export class Equipment {
    id: number;
    code: string;
    description: string;
}
